import React, { useState } from "react"
import clsx from "clsx"
import {
	Grid,
	Typography,
	Checkbox,
	ListItem
} from "@material-ui/core"

import {
	Divider,
	AccessibleDrawer
} from "@/components"
import useChatStyles from "@/pages/Attendance/Chat/styles"
import useSidebarDrawerStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/styles"
import useDidMount from "@/hooks/useDidMount"

import HeaderDrawer from "@/pages/Attendance/Chat/HeaderDrawer"

import ErrorHandlerService from "@/services/ErrorHandler"
import useValidation, { ErrorType } from "@/hooks/useValidation"

import { useGlobalStateStore } from "@/store/GlobalState"

import useSettings from "@/hooks/useSettings"
import { isSmallScreen } from "@/utils/checkDevice"
import { UserConversationSettingsProps, UserSettingsKeysValues } from "@/protocols/settings"
import { Alert } from "@material-ui/lab"

type UserSettingsMenuProps = {
	openDrawer: boolean
	onClose: () => void
	isCollapsed: boolean
}

const ConversationSettings = (props: UserSettingsMenuProps) => {
	const { openDrawer, onClose, isCollapsed } = props

	const chatClasses = useChatStyles()
	const sidebarDrawerClasses = useSidebarDrawerStyles({ isCollapsed })
	const globalStateStore = useGlobalStateStore()
	const { userSettings } = useSettings()

	const [conversationConfiguration, setConversationConfiguration] = useState(Boolean)

	const {
		triggerValidation
	} = useValidation()

	const getActiveChannelIndex = function () {
		const activeChannelId = Number(globalStateStore?.currentChannel?.id)
		const activeChannelIndex = globalStateStore.channels.map(channel => channel.id).indexOf(activeChannelId)
		return activeChannelIndex
	}

	const handleChangeConversation = async () => {
		try {
			const setting: Extract<keyof UserSettingsKeysValues, "conversation"> = "conversation"
			const activeChannelIndex = getActiveChannelIndex()

			const actualSettings = globalStateStore?.channels?.[activeChannelIndex]?.settings?.[setting]
			const newPresenceSetting = !(actualSettings?.sendPresence)

			setConversationConfiguration(newPresenceSetting)

			await userSettings.updateActualUserSettings(setting, {
				sendPresence: newPresenceSetting
			})
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
			triggerValidation(error as ErrorType)
		}
	}

	const handleCloseDrawer = () => {
		onClose()
	}

	const getUserConversationSettings = async () => {
		try {
			const activeChannelIndex = getActiveChannelIndex()

			const settings = globalStateStore?.channels?.[activeChannelIndex]?.settings?.conversation || await userSettings.retrieveActualUserSetting("conversation") as UserConversationSettingsProps

			setConversationConfiguration(settings?.sendPresence)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
			triggerValidation(error as ErrorType)
		}
	}

	const eventKeyDownHandler = (event: KeyboardEvent) => {
		const { key } = event

		if (key === "Escape") {
			handleCloseDrawer()
		}
	}

	useDidMount(() => {
		window.addEventListener(
			"keydown",
			eventKeyDownHandler,
			{ capture: true }
		)
		getUserConversationSettings()
	})

	return (
		<AccessibleDrawer
			id="new-convesation-drawer"
			anchor="left"
			open={openDrawer}
			variant="persistent"
			onClose={handleCloseDrawer}
			onMobileBackButtonPress={handleCloseDrawer}
			classes={{
				paper: clsx(chatClasses.drawerPaper, !isSmallScreen && sidebarDrawerClasses.drawerPaperOffset)
			}}
		>
			<Grid container>
				<Grid item xs={12}>
					<HeaderDrawer
						title="Configurar conversa"
						onClose={handleCloseDrawer}
					/>
				</Grid>

				<Divider size={2} orientation="horizontal" />

				<Grid
					item
					xs
				>
					<ListItem
						button
						onClick={handleChangeConversation}
					>
						<Grid item>
							<Checkbox
								checked={conversationConfiguration}
								name="presence-check-box"
							/>
						</Grid>

						<Grid item>
							<Typography variant="h2" color="textPrimary">
								Mostrar digitando e gravando aúdio
							</Typography>
						</Grid>

					</ListItem>
					<ListItem>
						<Grid item>
							<Alert color="warning" icon={false} style={{ borderRadius: "6px" }}>
								<Grid container style={{ padding: "2px 20px" }} spacing={1}>
									<Grid item>
										<li>
											Caso essa opção esteja habilitada, mostraremos &quot;digitando&quot; ou &quot;gravando áudio&quot; para seu cliente antes de enviar mensagens.
										</li>
									</Grid>
									<Grid item>
										<li>
											Não será possível ver &quot;digitando&quot; e &quot;gravando áudio&quot; através da Letalk.
										</li>
									</Grid>
								</Grid>
							</Alert>
						</Grid>
					</ListItem>
				</Grid>

			</Grid>
		</AccessibleDrawer>
	)
}

export default ConversationSettings
